module.exports = __webpack_public_path__ + "images/rollsroyce_smallb74d2829e42eb1c21b52b406446398ae.png";